// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3dp9R","icon":"style_icon__2p84Q"};